import {
  type AppFieldExtendedReactFormApi,
  createFormHook,
  createFormHookContexts,
} from '@tanstack/react-form'

const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts()

export { useFieldContext, useFormContext }

export const { useAppForm, useTypedAppFormContext } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
})

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-object-type -- TanStack Form's 12 validator/meta generics have no narrower common type; {} matches our empty fieldComponents/formComponents config */
export type UseAppForm<TFormData = unknown> = AppFieldExtendedReactFormApi<
  TFormData,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  any,
  {},
  {}
>
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-object-type */
